import { render, staticRenderFns } from "./dongtai.vue?vue&type=template&id=2202c6c8&scoped=true"
import script from "./dongtai.vue?vue&type=script&lang=js"
export * from "./dongtai.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2202c6c8",
  null
  
)

export default component.exports